export default "__VITE_ASSET__mi81P$wY__"